/* import __COLOCATED_TEMPLATE__ from './delete-account-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { closeModal } from 'sh-www/utils/modal-controls';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';

const CLASS_NAME = 'SH-c-modal-delete-account';

class DeleteAccountModal extends Component {
  @tracked password = '';
  @tracked errors = {};
  @tracked isUserDeletable;

  get className() {
    return CLASS_NAME;
  }

  @dropTask
  *initializeData() {
    this.isUserDeletable = yield this.args.model.checkIfDeletable.perform();
  }

  @dropTask
  *handleSubmit() {
    try {
      yield this.args.model.requestDeletion.perform(this.password);
    } catch (error) {
      handleErrorResponse(this, error, ['password']);
      throw error;
    }
  }

  @action
  handleClose() {
    closeModal(this);
  }

  @action
  handlePasswordInput(value) {
    this.password = value;
    this.errors = {};
  }
}

export default DeleteAccountModal;
